import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('riq_theme') || 'dark');

  useEffect(() => {
    localStorage.setItem('riq_theme', theme);
  }, [theme]);

  const toggle = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));
  const isDark = theme === 'dark';

  // Design tokens (per design_guidelines.json - Luxury Swiss dual theme)
  const t = isDark
    ? {
        bg: 'bg-slate-950', surface: 'bg-slate-900/50', surfaceSolid: 'bg-slate-900',
        text: 'text-white', text2: 'text-slate-400', border: 'border-slate-800/60',
        header: 'bg-slate-950/80', input: 'bg-slate-900 border-slate-700 text-white placeholder-slate-500',
        chip: 'bg-slate-800 text-slate-300 border-slate-700',
        hover: 'hover:bg-slate-800/60'
      }
    : {
        bg: 'bg-slate-50', surface: 'bg-white', surfaceSolid: 'bg-white',
        text: 'text-slate-900', text2: 'text-slate-600', border: 'border-slate-200',
        header: 'bg-white/80', input: 'bg-white border-slate-300 text-slate-900 placeholder-slate-400',
        chip: 'bg-slate-100 text-slate-700 border-slate-200',
        hover: 'hover:bg-slate-100'
      };

  return (
    <ThemeContext.Provider value={{ theme, isDark, toggle, t }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};
